import React, { useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@mui/material';
import { Delete, ErrorOutline } from '@mui/icons-material';
import { InputText } from 'primereact/inputtext';
import Strings from '../../../i18n';
import { IDeleteButtonWithValidationProps } from './deleteButtonWithValidationProps';
import { colors } from '../../../constants/colors';

export const DeleteButtonWithValidation = ({
  onDelete,
  textConfirmation,
  titleConfirmation,
  textIcon,
  showDeleteIcon,
  colorBtn,
  textValidation,
  validationKey
}: IDeleteButtonWithValidationProps) => {
  const [open, setOpen] = useState(false);
  const [challengeInput, setChallengeInput] = useState('');
  const [clickConfirm, setClickConfirm] = useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleDelete = () => {
    onDelete();
    handleClose();
  };

  return (
    <>
      <Button
        variant="outlined"
        color={colorBtn ?? 'error'}
        sx={{ width: '100%', justifyContent: 'space-between' }}
        onClick={() => handleClickOpen()}
      >
        {textIcon || Strings.common.delete}
        {showDeleteIcon && <Delete />}
      </Button>
      <Dialog
        sx={{
          '& .MuiDialog-paper': {
            width: '80%',
            maxHeight: 435
          }
        }}
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle
          id="alert-dialog-title"
          className="text-center"
          sx={{
            fontWeight: 'bold',
            fontSize: '2rem'
          }}
        >
          <p className="mb-0">
            <ErrorOutline
              sx={{ color: colors.yellowLight, fontSize: '6rem' }}
            />
          </p>
          {titleConfirmation}
        </DialogTitle>
        <DialogContent>
          <p className="text-center">{textConfirmation}</p>
          <DialogContentText
            id="alert-dialog-description"
            className="text-center"
          >
            <span className="fw-bold">{textValidation}</span>
          </DialogContentText>
          <DialogContentText id="alert-dialog-description">
            <InputText
              value={challengeInput}
              size="small"
              className="w-100"
              onChange={(e) => setChallengeInput(e.target.value)}
            />
          </DialogContentText>
          {clickConfirm && challengeInput !== validationKey && (
            <DialogContentText id="alert-dialog-description">
              {
                Strings.serverAccess.devices.proFlag
                  .confirmThisChallengeTextError
              }
            </DialogContentText>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleDelete}
            color="success"
            variant="contained"
            disabled={challengeInput !== validationKey}
          >
            {challengeInput !== validationKey
              ? `${Strings.locations.confirmThisChallengeText} ${validationKey}`
              : Strings.common.ok}
          </Button>
          <Button
            onClick={() => handleClose()}
            color="error"
            variant="contained"
          >
            {Strings.common.cancel}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
